module.exports = __webpack_public_path__ + "img/fb21.be99b3f6.jpg";